import fetchApi from './requests';
import { GetCreditDetailsUrl } from '../Routes/creditDetails.route';
import { NormalizedCreditDetailsDataType } from '../Types/creditDetails.type';

export const getCreditDetailsData = async (
  customerActivityId: number,
  uniqueId: number
): Promise<NormalizedCreditDetailsDataType> => {
  const response = await fetchApi(GetCreditDetailsUrl(), {
    customerActivityId,
    uniqueId
  });

  if (response?.ok) {
    const creditDetailsData = {
      ...response.data,
      usedCredits: response.data.customerActivityDetailResponseVmUsedInfos,
      activityDetails: response.data.customerActivityDetailResponseVmGet
    };
    delete creditDetailsData.customerActivityDetailResponseVmGet;
    delete creditDetailsData.customerActivityDetailResponseVmUsedInfos;

    return creditDetailsData;
  }
  return null;
};
